export default __webpack_public_path__ + "static/media/grafema_capitolio_11.6acab722.mp4";